import _toConsumableArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _readOnlyError from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/readOnlyError.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import dateRange from '@/components/newdaterange/index.vue';
import { formatMoney, parseTime } from "@/utils/util.js";
import { getCustomerList, updateCustomerStatus, changeErpCustomerStatus, deleteErpCustomer, updateCustomerblock, getChannelList, getTokenForLogin, updateCustomerinfo, downloadImportTemp, syncDyxContent, inviteErpSendEmail, getImportTimes, getaccountByerp, newErpAccount, newInvite as _newInvite, getInviteList, deleteInvite } from '@/services/customer/customerList';
import { mapState, mapMutations, mapGetters } from 'vuex';
import { getErpGroupList } from '@/services/customer/erpGrouped';
import { getErpList, getSellerList, getBusFormat, getPayersList } from '@/services/customer/erpCustomerList';
import Cookie from 'js-cookie';
import EditableCell from '../../components/editableCell/editableCell.vue';
import { editInviteRemark } from '../../services/customer/customerList';
var deleteType = {
  onlyAccount: 0,
  //仅删除账号
  accountAnderp: 1 //删除得意先和账号
};

/**
 * 得意先状态类型
 * @enum
 */
var _ErpCustomerStatusTypes = {
  /** 正常 **/
  NORMAL: 1,
  /** 取引终了 **/
  END: 3
};
export { _ErpCustomerStatusTypes as ErpCustomerStatusTypes };
export default {
  name: 'Customerlist',
  i18n: require('./i18n-customer'),
  components: {
    dateRange: dateRange,
    EditableCell: EditableCell
  },
  data: function data() {
    var _this = this;
    var testEmail = function testEmail(rule, value, callback) {
      var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (value != '' && !reg.test(value)) {
        callback(new Error(_this.$t('customerList.email_error')));
      } else {
        callback();
      }
    };
    var checkPhone = function checkPhone(rule, value, callback) {
      console.log(value, 'value是什么到底');
      var phoneReg = /^0?[1-9][0-9]{0,1}[0-9]{4}[0-9]{4}$/;
      var phoneReg1 = /^1[3456789]\d{9}$/;
      if (value == '' || phoneReg.test(value) || phoneReg1.test(value)) {
        callback();
      } else {
        callback(new Error(_this.$t('customer.tel_error')));
      }
    };
    var checkNewAccountEmail = function checkNewAccountEmail(rule, value, callback) {
      console.log(value, 'value是什么到底');
      var emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!_this.newAccountForm.phone && !_this.newAccountForm.email) {
        callback(new Error(_this.$t('customerList.placeEmail')));
      } else if (!_this.newAccountForm.phone && !emailReg.test(value)) {
        callback(new Error(_this.$t('customerList.rule3')));
      } else {
        callback();
      }
    };
    var checkNewAccountPhone = function checkNewAccountPhone(rule, value, callback) {
      console.log(value, 'value是什么到底');
      var phoneReg = /^0?[1-9][0-9]{0,1}[0-9]{4}[0-9]{4}$/;
      var phoneReg1 = /^1[3456789]\d{9}$/;
      if (!_this.newAccountForm.phone && !_this.newAccountForm.email) {
        callback(new Error(_this.$t('customerList.placePhone')));
      } else if (!_this.newAccountForm.email && !phoneReg.test(value) && !phoneReg1.test(value)) {
        callback(new Error(_this.$t('customer.tel_error')));
      } else {
        callback();
      }
    };
    var importColumns = [{
      title: this.$t('customerList.dyxProductNo'),
      dataIndex: 'number',
      scopedSlots: {
        customRender: 'number'
      }
    }, {
      title: this.$t('customerList.dyxName'),
      dataIndex: 'dyxName',
      scopedSlots: {
        customRender: 'dyxName'
      }
    }, {
      title: this.$t('customerList.whyError'),
      dataIndex: 'reason'
    }];
    var drawcolumns = [
    // 邀请码
    {
      title: this.$t('customerList.inviteCode'),
      dataIndex: 'inviteCode',
      key: 'inviteCode',
      scopedSlots: {
        customRender: 'invite'
      },
      width: '17%'
    },
    // 状态
    {
      title: this.$t('public.status'),
      dataIndex: 'status',
      key: 'status',
      scopedSlots: {
        customRender: 'status'
      },
      width: '15%'
    },
    // 账户信息
    {
      // title: this.$t('customerList.customerInfo'),
      key: 'customerInfo',
      slots: {
        title: 'customerInfoTitle'
      },
      dataIndex: 'customerInfo',
      scopedSlots: {
        customRender: 'userInfo'
      },
      width: '25%'
    },
    // 备注
    {
      title: this.$t('customerList.remark'),
      dataIndex: 'remark',
      key: 'remark',
      scopedSlots: {
        customRender: 'remark'
      },
      width: '35%',
      ellipsis: true
    },
    // 创建时间
    {
      title: this.$t('publicuse.createdtime'),
      dataIndex: 'createTime',
      key: 'createTime',
      // scopedSlots: { customRender: 'createTime' },
      width: '25%',
      ellipsis: true
    },
    // 操作
    {
      title: this.$t('publicuse.action'),
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
      align: 'left',
      width: '25%'
    }];
    return {
      importColumns: importColumns,
      leftCurrencySymbol: '',
      rightCurrencySymbol: '',
      //总的条数
      listTotal: 0,
      preNumber: '',
      AllSource: [],
      deyxGroup: [],
      qingqiuxianList: [],
      yetaiList: [],
      dandangzheList: [],
      visibleNickname: false,
      confirmLoadingNicakname: false,
      visibleImport: false,
      suucessNum: 0,
      errorNum: 0,
      importNum: 0,
      importData: [],
      errorVisible: false,
      nicknameForm: {
        email: '',
        phone: ''
      },
      inviteRegForm: {
        regUrl: '',
        email: '',
        phone: ''
      },
      erpCustomerName: '',
      rules: {
        email: [{
          required: false,
          message: this.$t('customerList.rule1'),
          trigger: 'blur'
        }, {
          pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
          message: this.$t('customerList.rule3'),
          trigger: 'change'
        }],
        phone: [{
          required: false,
          message: this.$t('customerList.rule2'),
          trigger: 'blur'
        }, {
          validator: checkPhone,
          trigger: 'blur'
        }]
      },
      // 新增账号弹窗form的rules
      newAccountFormRules: {
        email: [{
          validator: checkNewAccountEmail,
          trigger: 'blur'
        }],
        phone: [{
          validator: checkNewAccountPhone,
          trigger: 'blur'
        }],
        tempPwd: [{
          required: true,
          message: this.$t('customerList.placeTmpPwd'),
          trigger: 'blur'
        }]
      },
      //审核
      AllStatus: [{
        key: 1,
        value: this.$t('customerList.approval')
      }, {
        key: 2,
        value: this.$t('customerList.pass')
      }, {
        key: 3,
        value: this.$t('customerList.refuse')
      }],
      //状态
      AllStatus2: [{
        key: 1,
        value: this.$t('public.enable')
      }, {
        key: 0,
        value: this.$t('public.disable')
      }],
      //得意先状态
      AllStatus3: [{
        key: 1,
        value: this.$t('customerList.normal')
      }, {
        key: 3,
        value: this.$t('customerList.notNormal')
      }],
      //注册类型
      AllStatus4: [{
        key: 1,
        value: this.$t('customerList.self')
      }, {
        key: 2,
        value: this.$t('customerList.invite')
      }, {
        key: 3,
        value: this.$t('customerList.backRegister')
      } // 后台注册
      ],
      //关注公众号
      AllTypes: [{
        key: 0,
        value: this.$t('publicuse.no')
      }, {
        key: 1,
        value: this.$t('publicuse.yes')
      }],
      /* 黑名单 */
      AllBlacklistTypes: [{
        key: 0,
        value: this.$t('publicuse.no')
      }, {
        key: 1,
        value: this.$t('publicuse.yes')
      }],
      customerList: [],
      isTableLoading: false,
      advanced: false,
      // 查询参数
      listQuery: {
        page: 1,
        size: 20,
        //客户信息 名称/账号
        customerInfo: '',
        // 客户状态 0：正常  1：禁用
        customerStatus: undefined,
        // 关注公众号 0:未关注  1：已关注
        subscribe: undefined,
        //积分开始
        startPoint: '',
        endPoint: '',
        //注册来源
        channel: undefined,
        //注册开始时间
        registerStartTime: '',
        //注册结束时间
        registerEndTime: '',
        //订单数量开始
        orderNumberStart: '',
        orderNumberEnd: '',
        //黑名单 0:否  1：是
        black: undefined,
        //活跃开始时间
        visitStartTime: '',
        visitEndTime: '',
        //1 订单数量 2累计金额 3,最近活跃时间 4注册时间
        orderType: 4,
        //1 降序 2升序
        orderWay: 1,
        inviteCode: '' //唯一码
      },
      // 点击搜索的时候用到
      queryParam: {
        page: 1,
        size: 20,
        //客户信息 名称/账号
        customerInfo: '',
        //得意先信息
        erpCustomerInfo: '',
        registTimeStart: '',
        registTimeEnd: '',
        approvalResult: undefined,
        customerStatus: undefined,
        erpCustomerStatus: undefined,
        registType: undefined,
        customerGroupIdList: [],
        inviteCode: '',
        //唯一码
        payerInfo: undefined,
        busFormatCode: undefined,
        sellerCode: undefined,
        orderType: 1,
        //排序方式（1降序 2升序）
        ordrBy: 2,
        //排序字段(1邀请码 2注册时间3得意先code)
        importversion: undefined,
        //导入批次
        erpCustomerCodeStart: '',
        //得意先编号-起始（会在失焦时自动去除前缀 0）
        erpCustomerCodeEnd: '' //得意先编号-结束（会在失焦时自动去除前缀 0）
      },
      sortedInfo: {
        columnKey: 'registTime',
        order: "descend"
      },
      rowId: null,
      //账号id  编辑账号的时候用
      action: process.env.VUE_APP_API_BASE_URL + "/erp/customer/import",
      newheaders: {},
      syncLoading: false,
      visibleInvite: false,
      erpCustomerId: undefined,
      sendLoading: false,
      inviteRules: {
        email: [{
          required: false,
          validator: testEmail,
          trigger: 'change'
        }],
        phone: [{
          required: false,
          validator: checkPhone,
          trigger: 'change'
        }]
      },
      importTimesList: [],
      delerpVisible: false,
      delErplist: [],
      erpName: '',
      erpCode: '',
      accountLoading: false,
      deleteerpId: undefined,
      delerpLoading: false,
      sendLoadingPhone: false,
      // 新增账号表单数据
      newAccountForm: {
        erpCustomerId: '',
        phone: '',
        email: '',
        tempPwd: '',
        note: ''
      },
      newAccountModalVisible: false,
      // 新增账号 modal visible
      confirmLoadingNewAccount: false,
      // 新增账号确定按钮loading
      // 控制邀请码弹窗的显示隐藏
      drawerVisible: false,
      // 邀请码弹窗的数据
      drawdata: [],
      // 邀请码弹窗列表
      drawcolumns: drawcolumns,
      inviteDrawForm: {
        erpCustomerId: '',
        // 得意先id
        inviteCount: 1,
        // 邀请码数量
        erpCustomerCode: '',
        // 得意先code
        erpCustomerName: '' // 得意先名称
      },
      newInviteLoading: false,
      // 新增邀请码loading
      inviteTableLoading: false // 邀请码table loading
    };
  },
  filters: {},
  watch: {
    '$route.query.approvalResult': function $routeQueryApprovalResult() {
      if (this.$route.query.approvalResult) {
        this.queryParam.approvalResult = 1;
        this.advanced = true;
        this.getList();
      }
    }
  },
  created: function created() {
    var _this$$route$query$ap;
    this.newheaders = {
      "x-auth-token": Cookie.get("x-auth-token")
    };
    this.leftCurrencySymbol = localStorage.getItem('leftCurrencySymbol');
    this.rightCurrencySymbol = localStorage.getItem('rightCurrencySymbol');
    var goParams = (_this$$route$query$ap = this.$route.query.approvalResult) !== null && _this$$route$query$ap !== void 0 ? _this$$route$query$ap : '';
    if (goParams) {
      this.queryParam.approvalResult = 1;
      this.advanced = true;
    }
    this.getList();
    this.getAllSource();
  },
  computed: _objectSpread(_objectSpread({}, mapState('setting', ['erpInviteContent1', 'erpInviteContent2', 'erpInviteContent3'])), {}, {
    columns: function columns() {
      var sortedInfo = this.sortedInfo;
      sortedInfo = sortedInfo || {};
      var columns = [{
        title: this.$t('customerList.customer'),
        dataIndex: 'customerInfo',
        key: 'customerInfo',
        scopedSlots: {
          customRender: 'customername' //自定义表格里面的内容
        },
        ellipsis: true,
        width: '180px'
      },
      // 审核结果
      {
        title: this.$t('customerList.approvalResult'),
        dataIndex: 'approvalResult',
        key: 'approvalResult',
        width: '90px',
        scopedSlots: {
          customRender: 'approvalResult' //自定义表格里面的内容
        },
        align: 'center'
      },
      //状态
      // {
      // 	title: this.$t('publicuse.status'),
      // 	dataIndex: 'customerStatus',
      // 	key: 'customerStatus',
      // 	width: '90px',
      // 	scopedSlots: {
      // 		customRender: 'customerStatus',
      // 	},
      // 	align: 'center'
      // },
      //注册时间
      {
        dataIndex: 'registTime',
        key: 'registTime',
        width: '160px',
        defaultSortOrder: 'descend',
        slots: {
          title: 'timeTitle'
        },
        scopedSlots: {
          customRender: 'registTime'
        },
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'registTime' && sortedInfo.order
      },
      // 得意先信息
      {
        title: this.$t('customerList.customerInfo2'),
        dataIndex: 'dyxMessage',
        key: 'dyxMessage',
        width: '200px',
        scopedSlots: {
          customRender: 'dyxMessage'
        },
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'dyxMessage' && sortedInfo.order
      },
      // {
      // 	title: this.$t('customerList.erpCustomerStatus'),
      // 	dataIndex: 'erpCustomerStatus',
      // 	key: 'erpCustomerStatus',
      // 	width: '100px',
      // 	scopedSlots: {
      // 		customRender: 'erpCustomerStatus',
      // 	},
      // 	align: 'center'
      // },
      // 得意先电话 改为联系方式
      {
        title: this.$t('customerList.erpCustomerPhone'),
        dataIndex: 'erpCustomerPhone',
        key: 'erpCustomerPhone',
        width: '150px',
        scopedSlots: {
          customRender: 'erpCustomerPhone'
        }
      },
      // 请求先编号
      {
        title: this.$t('customerList.payerCode'),
        dataIndex: 'payerCode',
        key: 'payerCode',
        width: '110px',
        scopedSlots: {
          customRender: 'payerCode'
        }
      },
      // 担当者
      {
        title: this.$t('customerList.sellerName'),
        dataIndex: 'sellerName',
        key: 'sellerName',
        width: '100px',
        scopedSlots: {
          customRender: 'sellerName'
        }
      },
      //邀请码
      {
        // title: this.$t('customerList.inviteCode'),
        dataIndex: 'inviteCode',
        key: 'inviteCode',
        width: '140px',
        slots: {
          title: 'inviteCodeTitle'
        },
        scopedSlots: {
          customRender: 'inviteCode'
        },
        align: 'right'
        // sorter: true,
        // sortOrder: sortedInfo.columnKey === 'inviteCode' && sortedInfo.order
      }, {
        title: this.$t('customerList.updateTime'),
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '100px',
        scopedSlots: {
          customRender: 'lastUpdateTime'
        },
        sorter: true,
        sortOrder: sortedInfo.columnKey === 'lastUpdateTime' && sortedInfo.order
      }, {
        title: this.$t('publicuse.action'),
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        width: '160px'
      }];
      return columns;
    },
    columns2: function columns2() {
      var sortedInfo = this.sortedInfo;
      sortedInfo = sortedInfo || {};
      var columns2 = [{
        title: this.$t('customerList.customer'),
        dataIndex: 'customerInfo',
        key: 'customerInfo',
        scopedSlots: {
          customRender: 'customername' //自定义表格里面的内容
        },
        ellipsis: true,
        width: '180px'
      },
      // 审核结果
      {
        title: this.$t('customerList.approvalResult'),
        dataIndex: 'approvalResult',
        key: 'approvalResult',
        width: '100px',
        scopedSlots: {
          customRender: 'approvalResult' //自定义表格里面的内容
        },
        align: 'center'
      }];
      return columns2;
    },
    ErpCustomerStatusTypes: function ErpCustomerStatusTypes() {
      return _ErpCustomerStatusTypes;
    }
  }),
  methods: {
    /** 邀请码弹窗跳转编辑得意先 **/inviteToEdit: function inviteToEdit(row) {
      var _row$customerInfo$cus;
      this.$router.push({
        path: '/customermanager/editcustomer2',
        query: {
          customerId: row.customerInfo ? (_row$customerInfo$cus = row.customerInfo.customerId) !== null && _row$customerInfo$cus !== void 0 ? _row$customerInfo$cus : '' : '',
          erpCustomerId: this.inviteDrawForm.erpCustomerId
        }
      });
    },
    /** 邀请码弹窗点击邀请注册 **/handleInviteRegister: function handleInviteRegister(record) {
      this.inviteRegister({
        inviteRegisterUrl: record.inviteRegisterUrl,
        erpCustomerId: this.inviteDrawForm.erpCustomerId,
        erpCustomerName: this.inviteDrawForm.erpCustomerName,
        InviteCode: record.inviteCode
      });
    },
    // 点击邀请码
    openInvite: function openInvite(record) {
      this.inviteDrawForm.erpCustomerId = record.erpCustomerId;
      this.inviteDrawForm.erpCustomerName = record.erpCustomerName;
      this.inviteDrawForm.erpCustomerCode = record.erpCustomerCode;
      this.drawerVisible = true;
      this.getInviteListData();
    },
    /** 确认删除邀请码 */confirmDeleteInvite: function confirmDeleteInvite(record) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return deleteInvite(record.id);
            case 1:
              res = _context.v;
              if (res.data.code === 200) {
                _this2.$message.success(_this2.$t('public.deleteSuccessfully'));
                _this2.getInviteListData();
              }
            case 2:
              _context.p = 2;
              return _context.f(2);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0,, 2, 3]]);
      }))();
    },
    /**邀请码弹窗关闭事件 */drawerClose: function drawerClose() {
      this.drawerVisible = false;
      this.inviteDrawForm.erpCustomerId = '';
      this.inviteDrawForm.erpCustomerName = '';
      this.inviteDrawForm.erpCustomerCode = '';
      this.inviteDrawForm.inviteCount = 1;
      this.drawdata = [];
      this.getList();
    },
    /**切换抽屉时动画结束后的回调 */afterVisibleChange: function afterVisibleChange(val) {
      console.log(val, 'visible');
    },
    /** 邀请码编辑备注 */saveInviteRemark: function saveInviteRemark(value, id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var params, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                id: id,
                remark: value
              };
              if (!_this3.editInviteRemarkLoading) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _this3.editInviteRemarkLoading = true;
              _context2.p = 2;
              _context2.n = 3;
              return editInviteRemark(params);
            case 3:
              res = _context2.v;
              console.log('res', res);
              if (res.data.code === 200) {
                _this3.$message.success(_this3.$t('public.saveSuccessfully'));
                _this3.getInviteListData();
              }
            case 4:
              _context2.p = 4;
              _this3.editInviteRemarkLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, null, [[2,, 4, 5]]);
      }))();
    },
    /** 获取邀请码列表 **/getInviteListData: function getInviteListData() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _this4.inviteTableLoading = true;
              params = {
                erpCustomerId: _this4.inviteDrawForm.erpCustomerId
              };
              _context3.p = 1;
              _context3.n = 2;
              return getInviteList(params);
            case 2:
              res = _context3.v;
              console.log('res', res);
              if (res.data.code === 200) {
                _this4.drawdata = res.data.data.list;
                console.log('drawdata', _this4.drawdata);
              }
            case 3:
              _context3.p = 3;
              _this4.inviteTableLoading = false;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[1,, 3, 4]]);
      }))();
    },
    /** 新增邀请码 **/newInvite: function newInvite() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params, res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (!_this5.newInviteLoading) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              console.log('this.inviteDrawForm.inviteCount', _this5.inviteDrawForm.inviteCount);
              if (!_.isNil(_this5.inviteDrawForm.inviteCount)) {
                _context4.n = 2;
                break;
              }
              _this5.$message.warning(_this5.$t('customerList.inviteCountRequired'));
              return _context4.a(2);
            case 2:
              params = {
                erpCustomerId: _this5.inviteDrawForm.erpCustomerId,
                addNum: _this5.inviteDrawForm.inviteCount
              };
              _this5.newInviteLoading = true;
              _context4.p = 3;
              _context4.n = 4;
              return _newInvite(params);
            case 4:
              res = _context4.v;
              if (res.data.code == 200) {
                _this5.$message.success(_this5.$t('public.addSuccessfully'));
                _this5.getInviteListData();
              }
            case 5:
              _context4.p = 5;
              _this5.newInviteLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, null, [[3,, 5, 6]]);
      }))();
    },
    // 新增账号弹窗取消
    handleCancelNewAccount: function handleCancelNewAccount() {
      this.$refs.newAccountForm.resetFields();
      this.newAccountModalVisible = false;
    },
    // 新增账号弹窗确定
    handleOkNewAccount: function handleOkNewAccount() {
      var _this6 = this;
      this.$refs['newAccountForm'].validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(valid) {
          var params, res;
          return _regenerator().w(function (_context5) {
            while (1) switch (_context5.n) {
              case 0:
                if (!valid) {
                  _context5.n = 4;
                  break;
                }
                _this6.confirmLoadingNewAccount = true;
                _context5.p = 1;
                params = {
                  erpCustomerId: _this6.newAccountForm.erpCustomerId,
                  email: _this6.newAccountForm.email,
                  phone: _this6.newAccountForm.phone,
                  tempPwd: _this6.newAccountForm.tempPwd,
                  note: _this6.newAccountForm.note
                };
                _context5.n = 2;
                return newErpAccount(params);
              case 2:
                res = _context5.v;
                if (res.data.code == 200) {
                  _this6.$message.success(_this6.$t('public.updateSuccessfully'));
                  _this6.getList();
                  _this6.newAccountModalVisible = false;
                  _this6.$refs.newAccountForm.resetFields();
                }
              case 3:
                _context5.p = 3;
                _this6.confirmLoadingNewAccount = false;
                return _context5.f(3);
              case 4:
                return _context5.a(2);
            }
          }, _callee5, null, [[1,, 3, 4]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    // 添加账号
    addErpCustomer: function addErpCustomer(record) {
      this.newAccountForm.erpCustomerId = record.erpCustomerId;
      this.newAccountModalVisible = true;
    },
    tableChange: function tableChange(pagination, filters, sorter, _ref2) {
      var currentDataSource = _ref2.currentDataSource;
      this.sortedInfo = sorter;
      this.queryParam.page = pagination.current;
      // this.listQuery.page = pagination.current
      this.queryParam.size = pagination.pageSize;
      // this.listQuery.size = pagination.pageSize
      if (sorter.columnKey) {
        if (typeof sorter.order == "undefined") {
          sorter.order = "ascend";
        }
        var order = sorter.order || "descend";
        var orders = order === "descend" ? 1 : 2;
        // this.$refs.brandList.$children[0].sSortOrder = sorter.order
        // if (sorter.columnKey == "orderNum") {
        // 	this.listQuery.orderType = 1
        // } else if (sorter.columnKey == "total") {
        // 	this.listQuery.orderType = 2
        // } else if (sorter.columnKey == "visitTime") {
        // 	this.listQuery.orderType = 3
        // } else {
        // 	this.listQuery.orderType = 4
        // }
        if (sorter.columnKey == "registTime") {
          this.queryParam.ordrBy = 2;
        } else if (sorter.columnKey == "dyxMessage") {
          this.queryParam.ordrBy = 3;
        } else if (sorter.columnKey == "inviteCode") {
          this.queryParam.ordrBy = 1;
        } else if (sorter.columnKey == "lastUpdateTime") {
          this.queryParam.ordrBy = 4;
        }
        this.queryParam.orderType = orders;
      }
      this.getList();
    },
    /* 获取注册来源列表 */getAllSource: function getAllSource() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var self, params1, res1, res2, res4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              // getChannelList().then(response => {
              // 	if (response.data.code == 200) {
              // 		this.AllSource = response.data.data
              // 	}
              // })
              self = _this7;
              params1 = {
                type: 1
              };
              _context6.n = 1;
              return getSellerList(params1);
            case 1:
              res1 = _context6.v;
              if (res1.data.code == 200) {
                _this7.dandangzheList = res1.data.data.map(function (item) {
                  return {
                    key: item.sellerCode,
                    value: item.sellerName
                  };
                });
              }
              // 获取业态列表
              _context6.n = 2;
              return getBusFormat();
            case 2:
              res2 = _context6.v;
              console.log(res2);
              if (res2.data.code == 200) {
                _this7.yetaiList = res2.data.data.map(function (item) {
                  return {
                    key: item.busFormatCode,
                    value: item.busFormatName
                  };
                });
              }
              // 得意先分组
              // let params = {
              //     sence: 2
              // }
              // const res =  await getErpGroupList(params)
              // if(res.data.code == 200) {
              //     this.deyxGroup = res.data.data.list.map(item => {
              //         return {
              //             key:item.groupId,
              //             value: item.groupName
              //         }
              //     })
              // }
              // 请求先
              _context6.n = 3;
              return getPayersList();
            case 3:
              res4 = _context6.v;
              if (res4.data.code == 200) {
                _this7.qingqiuxianList = res4.data.data.map(function (item) {
                  return {
                    key: item.payerCode,
                    value: item.payerName
                  };
                });
              }
              _this7.getImportNums();
            case 4:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getImportNums: function getImportNums() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var res5, reverseList;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return getImportTimes();
            case 1:
              res5 = _context7.v;
              if (res5.data.code == 200) {
                reverseList = res5.data.data.reverse();
                _this8.importTimesList = reverseList.map(function (item) {
                  return {
                    key: item,
                    value: _this8.$t('customerList.importversion', {
                      num: item
                    })
                  };
                });
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getList: function getList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var params, res, list;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _this9.isTableLoading = true;
              params = _.cloneDeep(_this9.queryParam);
              params.sellerCode = params.sellerCode ? params.sellerCode.join(',') : params.sellerCode;
              params.importversion = params.importversion ? params.importversion.join(',') : params.importversion;
              params.scene = 1;
              _context8.n = 1;
              return getErpList(params);
            case 1:
              res = _context8.v;
              try {
                if (res.data.code == 200) {
                  list = res.data.data.list.map(function (item) {
                    if (item.inviteCode && _.isString(item.inviteCode)) {
                      var _list = item.inviteCode.split(',');
                      item.inviteCodeUsed = _list[0];
                      item.inviteCodeTotal = _list[1];
                    }
                    return item;
                  });
                  _this9.customerList = list;
                  _this9.listTotal = res.data.data.total;
                }
              } finally {
                _this9.isTableLoading = false;
              }
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    /* 查询方法 */queryList: function queryList() {
      this.queryParam.page = 1;
      if (this.$route.query.approvalResult) {
        this.$router.replace({
          query: {}
        });
      }
      this.getList();
    },
    /* 启用，停用 */statusConfirm: function statusConfirm(record, type) {
      var _this0 = this;
      var updateObj = {
        id: record.id,
        status: type
      };
      updateCustomerStatus(updateObj).then(function (response) {
        if (response.data.code == 200) {
          _this0.$message.success(_this0.$t('public.updateSuccessfully'));
          _this0.getList();
        }
      });
      record.deleteVisible = false;
    },
    statusCancel: function statusCancel() {},
    formatMoney: formatMoney,
    //编辑
    updata: function updata(row) {
      var _row$customerInfo$cus2, _row$erpCustomerId;
      console.log(row, 'row....');
      this.$router.push({
        path: '/customermanager/editcustomer2',
        query: {
          customerId: row.customerInfo ? (_row$customerInfo$cus2 = row.customerInfo.customerId) !== null && _row$customerInfo$cus2 !== void 0 ? _row$customerInfo$cus2 : '' : '',
          erpCustomerId: (_row$erpCustomerId = row.erpCustomerId) !== null && _row$erpCustomerId !== void 0 ? _row$erpCustomerId : ''
        }
      });
    },
    loginFrontEnd: function loginFrontEnd(record) {
      console.log('record', record);
      var self = this;
      getTokenForLogin({
        customerId: record.customerInfo.customerId
      }).then(function (response) {
        console.log(response);
        if (response.data.code === 200) {
          var url = response.data.data;
          console.log(url);
          window.open(url);
        }
      });
    },
    changeregistrationtimeDate: function changeregistrationtimeDate(dateRange) {
      if (dateRange.startDateClone != undefined) {
        this.queryParam.registTimeStart = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.registTimeStart = "";
      }
      if (dateRange.endDateClone != undefined) {
        this.queryParam.registTimeEnd = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.registTimeEnd = "";
      }
    },
    changerecentactivetimeDate: function changerecentactivetimeDate(dateRange) {
      if (dateRange.startDateClone != undefined) {
        this.queryParam.visitStartTime = parseTime(dateRange.startDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.visitStartTime = "";
      }
      if (dateRange.endDateClone != undefined) {
        this.queryParam.visitEndTime = parseTime(dateRange.endDateClone._d, "{y}-{m}-{d}");
      } else {
        this.queryParam.visitEndTime = "";
      }
    },
    handleMenuClick: function handleMenuClick(record) {
      record.deleteVisible = true;
    },
    addNewCoupon: function addNewCoupon() {
      this.$router.push({
        name: "Newcoupon"
      });
    },
    handleAdjustquantity: function handleAdjustquantity(record) {},
    /* 确认拉黑 和确认解除拉黑 */
    // confirm(record, type) {
    // 	let updateObj = {
    // 		customerId: record.id,
    // 		blacklistType: type
    // 	}
    // 	updateCustomerblock(updateObj).then(response => {
    // 		if (response.data.code == 200) {
    // 			this.$message.success(this.$t('public.updateSuccessfully'));
    // 			this.getList()
    // 		}
    // 	})
    // 	record.deleteVisible = false
    // },
    /* 拉黑取消 */
    // cancel(record, type) {
    // 	record.deleteVisible = false
    // },
    handleTypeChange: function handleTypeChange(value) {
      this.queryParam.type = value;
    },
    //多选
    handleChange: function handleChange(value) {
      console.log(this.queryParam.status);
    },
    toggleAdvanced: function toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    /**
     * 去除得意先编号的前缀 0
     * 场景：用户从外部复制的编号常带前缀 0（如 02285），
     *       但后端匹配的是去掉前缀 0 的编号（如 2285），
     *       因此在输入框失焦时自动去除前缀 0，保证搜索命中。
     * @param {string} field - 要处理的字段名（'erpCustomerCodeStart' 或 'erpCustomerCodeEnd'）
     */
    trimErpCustomerCodeZero: function trimErpCustomerCodeZero(field) {
      // 取出当前值并转成字符串，去除首尾空格（粘贴时可能带空格）
      var rawValue = (this.queryParam[field] || '').toString().trim();
      // 去掉开头连续的 0；使用前瞻 (?=\d) 保证后面还有数字，
      // 这样全 0（如 "0000"）会被处理成 "0" 而不是被清空。
      var trimmedValue = rawValue.replace(/^0+(?=\d)/, '');
      // 回写到 queryParam，输入框会同步显示去 0 后的结果
      this.queryParam[field] = trimmedValue;
    },
    handleOkNickname: function handleOkNickname() {
      var _this1 = this;
      this.$refs['nicknameForm'].validate(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(valid) {
          var params, res;
          return _regenerator().w(function (_context9) {
            while (1) switch (_context9.n) {
              case 0:
                if (!valid) {
                  _context9.n = 4;
                  break;
                }
                _this1.confirmLoadingNicakname = true;
                _context9.p = 1;
                params = {
                  id: _this1.rowId,
                  customerEmail: _this1.nicknameForm.email,
                  customerPhone: _this1.nicknameForm.phone
                };
                _context9.n = 2;
                return updateCustomerinfo(params);
              case 2:
                res = _context9.v;
                if (res.data.code == 200) {
                  _this1.$message.success(_this1.$t('public.updateSuccessfully'));
                  _this1.getList();
                  _this1.visibleNickname = false;
                }
              case 3:
                _context9.p = 3;
                _this1.confirmLoadingNicakname = false;
                return _context9.f(3);
              case 4:
                return _context9.a(2);
            }
          }, _callee9, null, [[1,, 3, 4]]);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    handleCancelNickname: function handleCancelNickname() {
      this.$refs.nicknameForm.resetFields();
      this.visibleNickname = false;
    },
    handleOkInvite: function handleOkInvite() {},
    handleCancelInvite: function handleCancelInvite() {
      this.visibleInvite = false;
      this.inviteRegForm = {
        regUrl: '',
        email: '',
        phone: '',
        InviteCode: ''
      };
      this.$refs.inviteForm.clearValidate();
    },
    changeNickname: function changeNickname(row) {
      this.nicknameForm = {
        email: row.customerInfo.customerEmail,
        phone: row.customerInfo.customerPhone
      };
      this.rowId = row.customerInfo.customerId;
      this.rules['email'][0].required = row.customerInfo.customerType == 1 ? true : false;
      this.rules['phone'][0].required = row.customerInfo.customerType == 2 ? true : false;
      this.visibleNickname = true;
    },
    inviteRegister: function inviteRegister(row) {
      this.inviteRegForm = {
        regUrl: row.inviteRegisterUrl,
        email: row.inviteRegisterEmail ? row.inviteRegisterEmail : '',
        phone: '',
        InviteCode: row.InviteCode
      };
      this.erpCustomerId = row.erpCustomerId;
      this.erpCustomerName = row.erpCustomerName;
      this.visibleInvite = true;
    },
    sendEmail: function sendEmail() {
      var _this10 = this;
      this.$refs.inviteForm.validate(/*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(valid) {
          var obj, res;
          return _regenerator().w(function (_context0) {
            while (1) switch (_context0.n) {
              case 0:
                if (!valid) {
                  _context0.n = 2;
                  break;
                }
                _this10.sendLoading = true;
                obj = {
                  erpCustomerId: _this10.erpCustomerId,
                  email: _this10.inviteRegForm.email,
                  InviteCode: _this10.inviteRegForm.InviteCode
                };
                _context0.n = 1;
                return inviteErpSendEmail(obj);
              case 1:
                res = _context0.v;
                try {
                  if (res.data.code == 200) {
                    if (res.data.data.sendStatus == 1) {
                      _this10.$message.success(_this10.$t('customerList.sendSuccess'));
                      _this10.getList();
                    } else {
                      _this10.$message.error(_this10.$t('customerList.sendFaild'));
                    }
                  }
                } finally {
                  _this10.sendLoading = false;
                }
              case 2:
                return _context0.a(2);
            }
          }, _callee0);
        }));
        return function (_x3) {
          return _ref4.apply(this, arguments);
        };
      }());
    },
    sendPhone: function sendPhone() {
      var _this11 = this;
      this.$refs.inviteForm.validate(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(valid) {
          var obj, res;
          return _regenerator().w(function (_context1) {
            while (1) switch (_context1.n) {
              case 0:
                if (!valid) {
                  _context1.n = 2;
                  break;
                }
                _this11.sendLoadingPhone = true;
                obj = {
                  erpCustomerId: _this11.erpCustomerId,
                  phone: _this11.inviteRegForm.phone,
                  InviteCode: _this11.inviteRegForm.InviteCode
                };
                _context1.n = 1;
                return inviteErpSendEmail(obj);
              case 1:
                res = _context1.v;
                try {
                  if (res.data.code == 200) {
                    if (res.data.data.sendStatus == 1) {
                      _this11.$message.success(_this11.$t('customerList.sendSuccess'));
                      _this11.getList();
                    } else {
                      _this11.$message.error(_this11.$t('customerList.sendFaild'));
                    }
                  }
                } finally {
                  _this11.sendLoadingPhone = false;
                }
              case 2:
                return _context1.a(2);
            }
          }, _callee1);
        }));
        return function (_x4) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    handleOkImport: function handleOkImport() {
      this.visibleImport = false;
    },
    handleCancelImport: function handleCancelImport() {
      this.visibleImport = false;
    },
    importErp: function importErp() {
      this.visibleImport = true;
    },
    handleChangeImport: function handleChangeImport(info) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var fileList, newRes;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              fileList = _toConsumableArray(info.fileList);
              fileList = fileList.slice(-1);
              if (!(fileList[0].response != undefined)) {
                _context10.n = 3;
                break;
              }
              newRes = fileList[0].response;
              if (!(newRes.code == 200)) {
                _context10.n = 2;
                break;
              }
              _context10.n = 1;
              return _this12.getList();
            case 1:
              _this12.$message.success(_this12.$t('customer.importSuccess'));
              // this.isTableLoading = false
              _this12.errorVisible = true;
              _this12.importData = newRes.data.faillist ? newRes.data.faillist : [];
              _this12.suucessNum = newRes.data.successnum;
              _this12.errorNum = _this12.importData.length;
              _this12.importNum = newRes.data.importversion;
              // if (newRes.data.faillist.length > 0) {
              // 	this.isTableLoading = false
              // 	this.errorVisible = true
              // 	this.importData = newRes.data.faillist
              // 	this.suucessNum = newRes.data.successnum
              // 	this.errorNum = newRes.data.faillist.length
              // } else {
              // 	await this.getList()
              // 	this.$message.success(this.$t('customer.importSuccess'))
              // }
              _context10.n = 3;
              break;
            case 2:
              _this12.$notification.error({
                message: newRes.message
              });
              _this12.isTableLoading = false;
            case 3:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    beforeUpload: function beforeUpload(file) {
      var extension = file.name.split('.')[1] === 'xls';
      var extension2 = file.name.split('.')[1] === 'xlsx';
      var isLt5M = file.size / 1024 / 1024 < 10;
      if (!extension && !extension2) {
        this.$message.error(this.$t("public.exportpromptone"));
        return false;
      } else if (!isLt5M) {
        this.$message.error(this.$t("public.exportprompytwo"));
        return false;
      } else {
        this.isTableLoading = true;
      }
    },
    confirmDelete: function confirmDelete(row) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var res;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.p = 0;
              _this13.isTableLoading = true;
              _context11.n = 1;
              return deleteErpCustomer(row.erpCustomerId);
            case 1:
              res = _context11.v;
              if (res.data.code == 200) {
                _this13.$message.success(_this13.$t('public.deleteSuccessfully'));
                _this13.getList();
              }
            case 2:
              _context11.p = 2;
              _this13.isTableLoading = false;
              return _context11.f(2);
            case 3:
              return _context11.a(2);
          }
        }, _callee11, null, [[0,, 2, 3]]);
      }))();
    },
    cancelDelete: function cancelDelete() {},
    confirmEnabled: function confirmEnabled(row) {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var params, res;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              params = {
                id: row.customerInfo.customerId,
                customerStatus: 1 - row.customerInfo.customerStatus
              };
              _context12.p = 1;
              _this14.isTableLoading = true;
              _context12.n = 2;
              return changeErpCustomerStatus(params);
            case 2:
              res = _context12.v;
              if (res.data.code == 200) {
                _this14.$message.success(_this14.$t('public.updateSuccessfully'));
                _this14.getList();
              }
            case 3:
              _context12.p = 3;
              _this14.isTableLoading = false;
              return _context12.f(3);
            case 4:
              return _context12.a(2);
          }
        }, _callee12, null, [[1,, 3, 4]]);
      }))();
    },
    cancelEnabled: function cancelEnabled() {},
    downloadImport: function downloadImport() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var res, temp, name, blob, url, link;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              _context13.n = 1;
              return downloadImportTemp();
            case 1:
              res = _context13.v;
              temp = res.headers["content-disposition"];
              if (temp) {
                name = decodeURI(temp.split('=')[1]);
              } else {
                name = _this15.$t('customer.importTemplate') + '.xls';
              }
              // console.log(res)
              blob = new Blob([res.data], {
                type: "application/vnd.ms-excel"
              });
              url = window.URL.createObjectURL(blob);
              link = document.createElement('a');
              link.style.display = 'none';
              link.download = name;
              link.href = url;
              link.click();
            case 2:
              return _context13.a(2);
          }
        }, _callee13);
      }))();
    },
    syncDyx: function syncDyx() {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var res;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _this16.syncLoading = true;
              _context14.n = 1;
              return syncDyxContent();
            case 1:
              res = _context14.v;
              if (res.data.code == 200) {
                _this16.$message.success(_this16.$t('public.updateSuccessfully'));
                _this16.syncLoading = false;
                _this16.getList();
              }
            case 2:
              return _context14.a(2);
          }
        }, _callee14);
      }))();
    },
    copy: function copy() {
      var _this17 = this;
      var input = document.getElementById("copyInput");
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        navigator.clipboard.writeText(input.innerText).then(function () {
          _this17.$message.success(_this17.$t('public.copySuccessfully'));
        });
      } else {
        console.log('no');
        var textArea = document.createElement("textarea");
        textArea.value = input.innerText;
        // 使text area不在viewport，同时设置不可见
        textArea.style.position = "absolute";
        textArea.style.opacity = 0;
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        // focus方法会导致复制后跳转到顶部 添加这个参数阻止滚动
        textArea.focus({
          preventScroll: true
        });
        textArea.select();
        return new Promise(function (res, rej) {
          // 执行复制命令并移除文本框
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
          _this17.$message.success(_this17.$t('public.copySuccessfully'));
        });
      }
    },
    delErpAndcustomer: function delErpAndcustomer(row) {
      var _this18 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var res;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _this18.delerpVisible = true;
              // 调用接口获取数据
              _this18.accountLoading = true;
              _context15.n = 1;
              return getaccountByerp(row.erpCustomerId);
            case 1:
              res = _context15.v;
              try {
                if (res.data.code == 200) {
                  console.log(res.data, '11');
                  _this18.erpName = res.data.data.erpCustomerName;
                  _this18.erpCode = res.data.data.erpCustomerCode;
                  _this18.delErplist = res.data.data.customerList;
                  _this18.deleteerpId = res.data.data.erpCustomerId;
                }
              } finally {
                _this18.accountLoading = false;
              }
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    handleCanceldel: function handleCanceldel() {
      this.delerpVisible = false;
    },
    handleDelete: function handleDelete() {
      var _this19 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
        var res;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.n) {
            case 0:
              _this19.delerpLoading = true;
              _context16.n = 1;
              return deleteErpCustomer(_this19.deleteerpId, deleteType.accountAnderp);
            case 1:
              res = _context16.v;
              try {
                if (res.data.code == 200) {
                  _this19.$message.success(_this19.$t('public.deleteSuccessfully'));
                  _this19.delerpVisible = false;
                  _this19.getList();
                }
              } finally {
                _this19.delerpLoading = false;
              }
            case 2:
              return _context16.a(2);
          }
        }, _callee16);
      }))();
    },
    confirmDeleteCustomer: function confirmDeleteCustomer(row) {
      var _this20 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var res;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              _this20.isTableLoading = true;
              // 调用接口 删除
              _context17.n = 1;
              return deleteErpCustomer(row.customerInfo.customerId, deleteType.onlyAccount);
            case 1:
              res = _context17.v;
              try {
                if (res.data.code == 200) {
                  _this20.$message.success(_this20.$t('public.deleteSuccessfully'));
                  _this20.getList();
                }
              } finally {
                _this20.isTableLoading = false;
              }
            case 2:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    },
    cancelDeleteCustomer: function cancelDeleteCustomer() {},
    handleCancelErrorErp: function handleCancelErrorErp() {
      var _this21 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              if (!(_this21.suucessNum > 0)) {
                _context18.n = 2;
                break;
              }
              _this21.queryParam.importversion = [_this21.importNum];
              _this21.queryParam.page = 1;
              console.log(_this21.queryParam.importversion, '1111111');
              _context18.n = 1;
              return _this21.getImportNums();
            case 1:
              _this21.getList();
            case 2:
              // this.queryParam.importversion = this.importTimesList.pop()
              _this21.errorVisible = false;
            case 3:
              return _context18.a(2);
          }
        }, _callee18);
      }))();
    }
  }
};